import { render, staticRenderFns } from "./resourcePie.vue?vue&type=template&id=cb09cf80&scoped=true"
import script from "./resourcePie.vue?vue&type=script&lang=js"
export * from "./resourcePie.vue?vue&type=script&lang=js"
import style0 from "./resourcePie.vue?vue&type=style&index=0&id=cb09cf80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb09cf80",
  null
  
)

export default component.exports